import React, { useState, useRef } from "react";
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import UIDatePicker from "components/datepicker";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import CommonUtil from 'utils/CommonUtil';
import DateUtil from "utils/DateUtil";
import UISelect from 'components/selectbox/UISelect';
import { CodeData } from "common/codedata/source/CodeDataSource";
import { Link } from 'react-router-dom';
import StringUtil from "utils/StringUtil";

function ContentsContainer() {
	const [totalRowCnt, setTotalRowCnt] = useState(0);
	const [showRowCnt, setShowRowCnt] = useState(20); //기본 row count
	const [ACCT_NO, SetACCT_NO] = useState('');
	const [ACCT_NO_S, SetACCT_NO_S] = React.useState<CodeData[]>();
	const [StartDate, setStartDate] = useState(new Date());
	const [EndDate, setEndDate] = useState(new Date());
	const [INOUT_GUBUN,	SetINOUT_GUBUN] = useState('');
	const [INOUT_AMT, SetINOUT_AMT] = useState('');
	const [JEOKYO, SetJEOKYO] = useState('');
	const [dateNum,setDateNum] = useState(0); 
	
    const [totInAmt, setTotInAmt] = useState('');
    const [totOutAmt, setTotOutAmt] = useState('');
    const [totIntAmt, setTotIntAmt] = useState('');
    const [totCalAmt, setTotCalAmt] = useState('');

    const [allTotInAmt, setAllTotInAmt] = useState('');
    const [allTotOutAmt, setAllTotOutAmt] = useState('');
    const [allTotIntAmt, setAllTotIntAmt] = useState('');
    const [allTotCalAmt, setAllTotCalAmt] = useState('');
    
    
    let SheetData = {};
    let totalCnt = useRef<number>(0);
	let defaultRowCnt = 20;
	let rowCnt = useRef<number>(20);
    	
	var ib = {
		//시트 초기화 구문
		'init':{
				"Cfg": {
					"SearchMode": 1,
					"PageLength": defaultRowCnt,
					"AutoRowHeight": 1,
					"InfoRowConfig": "0",
					"Alternate":"0",
					"Height": "737px",
			  		"Down2ExcelConfig" : {
	    				"sheetDesign":1,
	    				"merge":1
	  				}		
					
            
			},
				//틀고정 좌측 컬럼 설정
			"Cols": [
	            {"Header": "NO",		"Type": "Int",	"Name": "SEQ",					"RelWidth": 1,		"Align": "Center",	"CanEdit": 0},
	            {"Header": "거래일시",		"Type": "Text",	"Name": "ACCT_DAYTIME",			"RelWidth": 2,		"Align": "Center",	"CanEdit": 0},
	            {"Header": "계좌번호",		"Type": "Text",	"Name": "ACCT_NO",				"RelWidth": 2,		"Align": "left",	"CanEdit": 0},
	            {"Header": "입금",		"Type": "Int",	"Name": "IN_AMT",				"RelWidth": 2,		"Align": "Right",	"CanEdit": 0, "Format": "#,###"},
	            {"Header": "출금",		"Type": "Int",	"Name": "OUT_AMT",				"RelWidth": 2, 		"Align": "Right",	"CanEdit": 0, "Format": "#,###"},
	            {"Header": "의뢰인/수취인",	"Type": "Text",	"Name": "JEOKYO",				"RelWidth": 2,		"Align": "left",	"CanEdit": 0},
	            {"Header": "거래후 잔액",	"Type": "Int",	"Name": "BAL_AMT",				"RelWidth": 2, 		"Align": "Right",	"CanEdit": 0, "Format": "#,###"},
	            {"Header": "가상계좌번호",	"Type": "Text",	"Name": "VACCT_NO",				"RelWidth": 2,		"Align": "left",	"CanEdit": 0,  Visible : 0},
	            {"Header": "기업명",		"Type": "Text",	"Name": "CORP_NM",				"RelWidth": 2,		"Align": "left",	"CanEdit": 0,  Visible : 1},
         		{"Header": "거래상태",		"Type": "Text",	"Name": "TR_GB_NAME",			"RelWidth": 1,		"Align": "Center",	"CanEdit": 0},
            ],
       
		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {
				onClickSearch('init');				
				
			},

			onAfterGotoPage:function (evtParam) {
				var sheet = evtParam.sheet;
				var page = sheet.getPageIndex(sheet.getFocusedPage()) + 1;
		        //@ts-ignore
				if (currentPage !== -1 && currentPage !== page) {
					makePageIndex(page);
				}
			},
			
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;
		
			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'Main_sheet', // 생성할 시트의 id
				el: 'AcctList', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: SheetData
				
			});
			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},

		//엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			//@ts-ignore
			IBSheet.Main_sheet.down2Excel({fileName: "모계좌조회_"+today+".xlsx", SheetDesign:3, excelRowHeight:16.5, excelFontSize:10, downCols: "Visible"});
			
		},

	}

    async function onClickSearch(sAction:string) {
		const response:any = await CommonUtil.execute({
            url:"adm_2200_r001",
            data: {
				"ACCT_NO": ACCT_NO,
				"ACCT_TXDAY_STARTDATE" : DateUtil.toDateFormat(StartDate, "YYYYMMDD"),
				"ACCT_TXDAY_ENDDATE" : DateUtil.toDateFormat(EndDate, "YYYYMMDD"),
				"INOUT_GUBUN" : INOUT_GUBUN,
				"INOUT_AMT" : INOUT_AMT,
				"JEOKYO" : JEOKYO,
			}
        })
		.then((response: any) => {
	        if ( sAction === 'init'){
				var delItems: {code: string; name: string;}[] = [];
				// @ts-ignore
				var delItem: {code: string; name: string;} = {};
		
		    	// @ts-ignore
				var rows = response.REC;
				for (var i = 0; i < Object.keys(response.REC).length; i++) {
			        delItem = {
			            code: rows[i]["CODE"],
			            name: rows[i]["NAME"],
			        };
					
		 	    	delItems.push(delItem);
			  	}
		
				SetACCT_NO_S(delItems);
			}

			totalCnt.current = Object.keys(response.REC2).length;
			setTotalRowCnt(totalCnt.current);
			
			setTotInAmt(StringUtil.formatNumber(Number(response.TOTAL_IN_AMT)));
			setTotOutAmt(StringUtil.formatNumber(Number(response.TOTAL_OUT_AMT)));
			setTotIntAmt(StringUtil.formatNumber(Number(response.TOTAL_INT_AMT)));
			setTotCalAmt(StringUtil.formatNumber(Number(response.TOTAL_IN_AMT)-Number(response.TOTAL_OUT_AMT)+Number(response.TOTAL_INT_AMT)));

			setAllTotInAmt(StringUtil.formatNumber(Number(response.ALL_TOTAL_IN_AMT)));
			setAllTotOutAmt(StringUtil.formatNumber(Number(response.ALL_TOTAL_OUT_AMT)));
			setAllTotIntAmt(StringUtil.formatNumber(Number(response.ALL_TOTAL_INT_AMT)));
			setAllTotCalAmt(StringUtil.formatNumber(Number(response.ALL_TOTAL_IN_AMT)-Number(response.ALL_TOTAL_OUT_AMT)+Number(response.ALL_TOTAL_INT_AMT)));
			
			SheetData = response.REC2;
			// @ts-ignore
	        Main_sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
	        // @ts-ignore
	        Main_sheet.loadSearchData(SheetData);
	        // @ts-ignore
			makePageIndex(Main_sheet.getPageIndex(Main_sheet.getFocusedPage()) + 1); // 페이지 초기화

    	}).catch((error) => {
        	CommonUtil.showAxiosError(error);
        	return;
        	
    	});	
        

			    	
    }

    async function SetDate(value){
	    const newEndDate = new Date();
	    setEndDate(newEndDate);  // 종료 날짜를 오늘로 설정
	    const newStartDate = new Date(newEndDate);
	    newStartDate.setDate(newEndDate.getDate() - value);
	    setStartDate(newStartDate);  // 시작 날짜를 조정
    }
	
	const makePageIndex = function (tp:number) {
		try {
			if (tp == null) {
				//@ts-ignore
				currentPage = -1;
				return;
			}
	
			// @ts-ignore
			if (document.getElementById('pageNavi').firstChild) {
				// @ts-ignore
				document.getElementById('pageNavi').removeChild(document.getElementById('pageNavi').firstChild);
			}
	
			// @ts-ignore
			currentPage = tp;
			// @ts-ignore
			let sr = Main_sheet.getTotalRowCount(); // 전체 조회 건수
			// @ts-ignore
			let page = Main_sheet.PageLength; // 페이지당 레코드 수
			let thispage = tp; // 현재 페이지
			let pagecnt = 5; // 한번에 표시할 페이지 개수
			let lastpage = Math.ceil(sr / page); // 마지막 페이지 인덱스
			let li, tt, a;
			let ul = document.createElement('DIV');
			ul.style.textAlign = 'center';
	
			let k = 1;
	
			if (thispage !== 1) {
				let ul_sub = document.createElement('DIV');
				ul_sub.className ="group";
				li = document.createElement('Button');
				li.className = 'item first';
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				tt = document.createTextNode('<<');
				addEventHandler(li, 'click', pageMove, 1);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub.appendChild(li)
				ul.appendChild(ul_sub);
				
				li = document.createElement('Button');
				li.className = 'item prev';
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				addEventHandler(li, 'click', pageMove, tp - 1);
				tt = document.createTextNode('<');
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub.appendChild(li)
				ul.appendChild(ul_sub);
			}
	
			sr = (Math.ceil(tp / pagecnt) * pagecnt) - (pagecnt - 1);
			let ul_sub2 = document.createElement('DIV');
			ul_sub2.className ="group";
			for (let i = sr; i < (sr + pagecnt); i++) {
				if (i <= lastpage) {
					li = document.createElement('Button');
					li.className ="item";
					a = document.createElement('a');
					a.style.cursor = 'pointer';
					tt = document.createTextNode(String(i));
					addEventHandler(li, 'click', pageMove, i);
					if (i === tp) {
						li.className ="item active";
					}
					a.appendChild(tt);
					li.appendChild(a);
					ul_sub2.appendChild(li);
					ul.appendChild(ul_sub2);
				}
			}
	
			if (thispage < lastpage) {
				let ul_sub3 = document.createElement('DIV');
				ul_sub3.className ="group";	
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				li = document.createElement('Button');
				li.className = 'item next';
				tt = document.createTextNode('>');
				addEventHandler(li, 'click', pageMove, tp + 1);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub3.appendChild(li);
				ul.appendChild(ul_sub3);
				
				li = document.createElement('Button');
				li.className = 'item last';
				tt = document.createTextNode('>>');
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				addEventHandler(li, 'click', pageMove, lastpage);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub3.appendChild(li);
				ul.appendChild(ul_sub3);
			}
	
			ul.className = 'pg';
			// @ts-ignore
			document.getElementById('pageNavi').appendChild(ul);
		} catch (ex) {
			// @ts-ignore
			console.log(ex.message);
		}
	}
	
	
	const addEventHandler = function (obj, evtName, func, param) {
		if (obj.addEventListener) { // all browsers except IE before version 9
			obj.addEventListener(evtName, function () { func(param); }, false);
		} else if (obj.attachEvent) { // IE before version 9
			obj.attachEvent('on' + evtName, function () { func(param); });
		}
	}
	
	
	const pageMove = function (cPage:number) {
		// @ts-ignore
		Main_sheet.goToPageByIndex(cPage);
	}
	
	
	const handleSelect = (e) => {
		if(e.target.name === 'showRowCnt'){
			setShowRowCnt(e.target.value);
			rowCnt = e.target.value;
		   	// @ts-ignore
		   	IBSheet.disposeAll(true);		  
		   	ib.init.Cfg.PageLength = e.target.value;
		   	ib.create();
		   
		}
	};
		
	const activeEnter = (e) => {
		if(e.key === "Enter") {
			onClickSearch('search');
		}
	}
		
	React.useEffect(() => {
		StartDate.setDate(StartDate.getDate() - 30);
		SetACCT_NO('');
		SetINOUT_GUBUN('');
		SetINOUT_AMT('');
		SetJEOKYO('');
        // @ts-egnore
		ib.create();

        return () => {
          // @ts-ignore
          IBSheet.disposeAll(true);
        }
    },[])	
	
	return (
		<PageContainer>
			<LayoutAside />
				<div className="fww-con">

					<ul className="fww-brd">
						<li><Link to="/admin/">홈</Link></li>
						<li><Link to="#">관리자페이지</Link></li>
						<li><Link to="#">계좌관리</Link></li>
						<li><Link to="#">모계좌조회</Link></li>
					</ul>

					<main className="fww-main">
						<h1 className="tx tx-hd2">모계좌조회</h1>

						<div className="sf sf-3col">
							<div className="inner">
							<div className="sf-item">
									<p className="sf-key">계좌번호</p>
									<div className="sf-value">
										<div className="sl sl-md w100p">
											<UISelect
									        	className=""
									        	firstName={"all"}
									        	value={ACCT_NO}
									        	valueChanged={(value) => SetACCT_NO(value)}
									        	codeData={ACCT_NO_S}
									      	/>											
										</div>
									</div>
								</div>								
								<div className="sf-item sf-m-2-4">
									<p className="sf-key">거래일시</p>
									<div className="sf-value">
										<div className="fund-datepicker">
											<div className="hz-root hz-gap5">
												<UIDatePicker className="hz-item" value={StartDate} valueChanged={(value) => setStartDate(value)}/>
												<span className="hz-item">~</span>
												<UIDatePicker className="hz-item" value={EndDate} valueChanged={(value) => setEndDate(value)}/>
											</div>
											<div className="hz-item hz-root hz-gap5">
												<button className="bt" data-color={dateNum === 1 ? 'pri' : 'pri-o2'} data-size="md" type="button" onClick={()=> {SetDate(0); setDateNum(1);}}>오늘</button>
												<button className="bt" data-color={dateNum === 2 ? 'pri' : 'pri-o2'} data-size="md" type="button" onClick={()=> {SetDate(7); setDateNum(2);}}>1주일</button>
												<button className="bt" data-color={dateNum === 3 ? 'pri' : 'pri-o2'} data-size="md" type="button" onClick={()=> {SetDate(30); setDateNum(3);}}>1개월</button>
												<button className="bt" data-color={dateNum === 4 ? 'pri' : 'pri-o2'} data-size="md" type="button" onClick={()=> {SetDate(90); setDateNum(4);}}>3개월</button>
												<button className="bt" data-color={dateNum === 5 ? 'pri' : 'pri-o2'} data-size="md" type="button" onClick={()=> {SetDate(180); setDateNum(5);}}>6개월</button>
												<button className="bt" data-color={dateNum === 6 ? 'pri' : 'pri-o2'} data-size="md" type="button" onClick={()=> {SetDate(365); setDateNum(6);}}>1년</button>
											</div>
										</div>
									</div>
								</div>
								<div className="sf-item">
									<p className="sf-key">거래구분</p>
									<div className="sf-value">
										<div className="sl sl-md w100p">
											<UISelect
									        	className=""
									        	firstName={"all"}
									        	value={INOUT_GUBUN}
									        	valueChanged={(value) => SetINOUT_GUBUN(value)}
									        	codeData={[
													{ code: '1', name: '출금' },
													{ code: '2', name: '입금' }
												]}
									      	/>
										</div>
									</div>
								</div>
								<div className="sf-item">
									<p className="sf-key">금액</p>
									<div className="sf-value">
										<UIInput
											className={'tf tf-md w100p'}
											value={INOUT_AMT}
											valueChanged={(value) => SetINOUT_AMT(value)}
											placeholder={''}
											type='number'
											onKeyEnter={(e) => activeEnter(e)}
										/>
									</div>
								</div>
								<div className="sf-item">
									<p className="sf-key">의뢰인/수취인</p>
									<div className="sf-value">
										<UIInput
											className={'tf tf-md w100p'}
											value={JEOKYO}
											valueChanged={(value) => SetJEOKYO(value)}
											placeholder={''}
											onKeyEnter={(e) => activeEnter(e)} 
										/>
									</div>
								</div>
							</div>
						</div>
						<div className="hz-root hz-center mb30">
							<button className="bt" data-color="pri" data-size="md" type="button"  onClick={()=> onClickSearch('search')}>조회</button>
						</div>
						<div className="hz-root hz-gap15">
								<div className ="w60">
								</div>
								<div className="hz-item">
									<em className="fc-err">총 입금액</em> <span className="price">{allTotInAmt}</span>원
										&nbsp;- &nbsp;
									<em className="fc-pri">총 출금액</em>  <span className="price">{allTotOutAmt}</span>원
										&nbsp;+ &nbsp;
									<em className="fc-black">총 이자액</em>  <span className="price">{allTotIntAmt}</span>원
										&nbsp;= &nbsp;
									<em className="fc-black">합계</em> <span className="price">{allTotCalAmt}</span>원
								</div>								
						</div>
						<div className="tb-top">
							<div className="hz-root hz-gap15">
								<div className ="w60">
									<p className="tx fc-black"></p>총 <em className="fw500">{totalRowCnt}</em>건
								</div>
								<div className="hz-item">
									<em className="fc-err">조회일시 입금액</em> <span className="price">{totInAmt}</span>원
										&nbsp;- &nbsp;
									<em className="fc-pri">조회일시 출금액</em>  <span className="price">{totOutAmt}</span>원
										&nbsp;+ &nbsp;
									<em className="fc-black">조회일시 이자액</em>  <span className="price">{totIntAmt}</span>원
										&nbsp;= &nbsp;
									<em className="fc-black">합계</em> <span className="price">{totCalAmt}</span>원
								</div>
							</div>
							
							<div className="hz-root hz-gap5">
								<Button color="gray-o" size="sm" onClick={()=> ib.exportData()}>다운로드</Button>
								<div className="sl sl-sm w120">
									<select name="showRowCnt" id="showRowCnt" className="" value={showRowCnt}  onChange={(handleSelect)}>
										<option value="20">20개씩보기</option>
										<option value="50">50개씩보기</option>
										<option value="100">100개씩보기</option>
										<option value="200">200개씩보기</option>
										<option value="500">500개씩보기</option>
										<option value="1000">1000개씩보기</option>
									</select>
								</div>
							</div>
						</div>
						<div className="ibsheet" id='AcctList'></div>
						<div id="pageNavi" className="pg"></div>
					</main>
				</div>

		</PageContainer>
	);
}
export default ContentsContainer;